/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Override_TypeInputs */

const en_doc_override_type = /** @type {(inputs: Doc_Override_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change type`)
};

const pt_br2_doc_override_type = /** @type {(inputs: Doc_Override_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar tipo`)
};

/**
* | output |
* | --- |
* | "Change type" |
*
* @param {Doc_Override_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_override_type = /** @type {((inputs?: Doc_Override_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Override_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_override_type(inputs)
	return pt_br2_doc_override_type(inputs)
});